import Fuse from 'fuse.js';

export type Variant = {
  size: string;
  cost: number;
};

export type FoodItem = {
  order?: number;
  available?: boolean;
  hideInOnlineMenu?: boolean;
  type?: string;
  image?: string;
  variants: Variant[];
  [key: string]: any; // to allow any other fields like customGST, sacCode, etc.
};

type FoodCategory = Record<string, FoodItem>;
export type FoodData = Record<string, FoodCategory>;

export type SearchResult = {
  category: string;
  itemKey: string;
  item: FoodItem;
  matches?: any;
};

/**
 * Flattens nested food data into an array of searchable entries.
 */
function flattenData(data: FoodData): SearchResult[] {
  const result: SearchResult[] = [];

  for (const category in data) {
    const categoryItems = data[category];
    for (const itemKey in categoryItems) {
      result.push({
        category,
        itemKey,
        item: categoryItems[itemKey],
      });
    }
  }

  return result;
}

/**
 * Performs fuzzy search on item keys only, returning exact item data unchanged.
 */
export function fuzzySearchFoodItems(data: FoodData, query: string): SearchResult[] {
  if (!query.trim()) return [];

  const flatList = flattenData(data);

  const fuse = new Fuse(flatList, {
    keys: ['itemKey'],
    threshold: 0.4,
    ignoreLocation: true,
    includeMatches: true,
  });

  const results = fuse.search(query.trim());

  return results.map(result => ({
    category: result.item.category,
    itemKey: result.item.itemKey,
    item: result.item.item, // the full untouched item object
    matches: result.matches,
  }));
}
